import React, { useState } from 'react';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { MonthPanel } from './MonthPanel';
import { CalendarMapper } from '../../mapper';
import { CalendarView, CalendarViewComponentProps } from '../../types';
import { Calendar, CalendarConnector, CalendarEventCard, CalendarWithPanelLayout } from '../calendar';

export const MonthCalendar = ({ date, onNavigate, userProfileId }: CalendarViewComponentProps) => {
  const [showMyCalendar, setShowMyCalendar] = useState<boolean>(true);

  return (
    <CalendarWithPanelLayout>
      <CalendarConnector
        userProfileId={userProfileId}
        includeOwnEvents={showMyCalendar}
        period={CalendarEventsPeriod.Month}
        dateRange={CalendarMapper.getVisibleRange(CalendarView.Month, date)}
        children={props => (
          <Calendar
            step={10}
            date={date}
            timeslots={6}
            view={Views.MONTH}
            views={[Views.MONTH]}
            onNavigate={onNavigate}
            components={{
              event: props => <CalendarEventCard {...props} />,
            }}
            {...props}
          />
        )}
      />

      <MonthPanel
        date={date}
        onNavigate={onNavigate}
        showMyCalendar={showMyCalendar}
        onToggleMyCalendar={setShowMyCalendar}
      />
    </CalendarWithPanelLayout>
  );
};
